<template>
    <div v-if="loaded" class="nevs-content">
        <ModalAddCustomer :show="showAddCustomerModal" @done="addCustomerDone"></ModalAddCustomer>
        <div class="nevs-content-top-buttons">
            <NevsButton class="success help-save" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="form form-float">
            <NevsSelect v-model="dispatchNote.customer_id" :ajax="'select/customers'" :error="dispatchNoteValidation.customer_id"
                        :label="$LANG.Get('fields.customer')"></NevsSelect>
            <div v-if="this.selectedCustomer !== null" class="customer-details">
                {{ this.selectedCustomer.address }}<br/>
                {{ this.selectedCustomer.postal_code }} {{ this.selectedCustomer.city }}<br/>
                {{ this.selectedCustomer.country }}<br/>
            </div>
            <NevsButton @click="showAddCustomerModal = true">
                {{ $LANG.Get('buttons.addNewCustomer') }}
            </NevsButton>
        </NevsCard>
        <NevsCard class="form form-float help-dates">
            <NevsDateField v-model="timeOfIssue.date" :error="timeOfIssueValidation.date"
                           :label="$LANG.Get('fields.dateOfIssue')"></NevsDateField>
            <NevsMaskedField v-model="timeOfIssue.time" :error="timeOfIssueValidation.time"
                             :label="$LANG.Get('fields.timeOfIssue')"
                             :mask="'NN:NN:NN'"></NevsMaskedField>
        </NevsCard>
        <NevsCard class="form form-float">
            <NevsSelect v-if="showCurrency" v-model="dispatchNote.currency" :ajax="currencyEndpoint"
                        :error="dispatchNoteValidation.currency"
                        :label="$LANG.Get('fields.currency')" :readonly="currencyReadonly"></NevsSelect>
            <NevsSelect v-if="(mode === 'add' || mode === 'copy') && sequences.length > 1"
                        v-model="dispatchNote.dispatchNote_sequence_id"
                        :error="dispatchNoteValidation.dispatchNote_sequence_id" :label="$LANG.Get('fields.sequence')"
                        :options="sequences"></NevsSelect>
            <NevsSelect v-model="dispatchNote.locale"
                        :error="dispatchNoteValidation.locale" :label="$LANG.Get('fields.language')"
                        :ajax="'select/languages'"></NevsSelect>
            <NevsSelect v-model="dispatchNote.payment_method_id" :ajax="'select/payment-methods-nullable'"
                        :error="dispatchNoteValidation.payment_method_id" :label="$LANG.Get('fields.paymentMethod')"></NevsSelect>
        </NevsCard>
        <NevsCard class="items-card">
            <NevsSelect v-model="selectedProduct" :ajax="'select/products'" :error="dispatchNoteValidation.items"
                        :label="$LANG.Get('labels.selectItem')" class="item-select help-item"></NevsSelect>
            <NevsButton class="details-button" @click="toggleDetails()"><i class="fa-solid fa-eye"></i> {{ $LANG.Get('buttons.details') }}</NevsButton>
            <div class="items-container">
                <table v-show="dispatchNote.items.length !== 0" class="items-table">
                    <thead>
                    <tr class="items-table-header">
                        <td v-for="(header, key) in headers" :key="key" :style="{'width': header.width}">{{
                                header.text
                            }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in dispatchNote.items" :key="key">
                        <td class="items-table-buttons">
                            <NevsButton @click="removeItemClick(key)"><i class="fa-solid fa-trash"></i></NevsButton>
                        </td>
                        <td>
                            <NevsTextField v-model="item.description" :readonly="item.product_id!==null"></NevsTextField><br />
                            <NevsTextArea v-if="showDetails" v-model="item.details"></NevsTextArea>
                        </td>
                        <td>
                            <NevsSelect v-model="item.measurement_unit_id" :readonly="item.product_id!==null"
                                        :ajax="'select/measurement-units'"></NevsSelect>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.price"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.quantity" :decimal-places="3"
                                             :thousand-separator="''"></NevsNumberField>
                        </td>
                        <td v-if="dispatchNote.tax_system && !dispatchNote.ppo">
                            <NevsNumberField v-model="item.tax"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.discount"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField :readonly="true" v-model="item.total"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table v-show="dispatchNote.items.length !== 0" class="summary-table">
                    <tbody>
                    <tr>
                        <td class="sub-table-left">{{ $LANG.Get('labels.additionalDiscount') }} (%):</td>
                        <td class="sub-table-right">
                            <NevsNumberField v-model="dispatchNote.discount" :thousand-separator="''"></NevsNumberField>
                        </td>
                    </tr>
                    <tr v-for="(base, key) in taxBases" :key="key">
                        <td>
                            {{ $LANG.Get('labels.taxBase') }} {{ base.base }} ({{ dispatchNote.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="base.value" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $LANG.Get('fields.total') }} ({{ dispatchNote.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="total" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="nevs-clear-float"></div>
            </div>
        </NevsCard>
        <NevsCard class="footer-container">
            <NevsTextField v-model="dispatchNote.order_form" :label="$LANG.Get('fields.orderForm')"></NevsTextField>
            <NevsTextField v-model="dispatchNote.shipping_method" :label="$LANG.Get('fields.shippingMethod')"></NevsTextField>
            <NevsTextField v-model="dispatchNote.received_by" :label="$LANG.Get('fields.receivedBy')"></NevsTextField>
            <NevsTextArea v-model="dispatchNote.footer" :error="dispatchNoteValidation.footer"
                          :label="$LANG.Get('fields.footer')"></NevsTextArea>
            <NevsCheckbox v-model="dispatchNote.ppo" :label="$LANG.Get('fields.ppo')" class="help-ppo"></NevsCheckbox>
            <NevsTextField v-if="dispatchNote.ppo" v-model="dispatchNote.ppo_text"
                           :label="$LANG.Get('fields.ppoText')"></NevsTextField>
            <NevsSelect class="bank-field" v-if="ibanOptions.length > 1" :label="$LANG.Get('fields.iban')"
                        v-model="dispatchNote.iban" :options="ibanOptions"></NevsSelect>
            <NevsSelect class="bank-field" v-if="swiftOptions.length > 1" :label="$LANG.Get('fields.swift')"
                        v-model="dispatchNote.swift" :options="swiftOptions"></NevsSelect>
            <NevsCheckbox v-model="dispatchNote.show_financial_data"
                           :label="$LANG.Get('fields.showFinancialData')"></NevsCheckbox>
        </NevsCard>
    </div>
</template>

<script>
import DispatchNote from '@/models/DispatchNote.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import Big from 'big.js';
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsMaskedField from "@/components/nevs/NevsMaskedField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import ModalAddCustomer from "@/components/modals/ModalAddCustomer.vue";
import moment from "moment";

export default {
    name: "EntityDispatchNote",
    components: {
        ModalAddCustomer,
        NevsCheckbox,
        NevsTextArea,
        NevsNumberField, NevsTextField, NevsMaskedField, NevsDateField, NevsSelect, NevsButton, NevsCard
    },
    data() {
        return {
            invoiceNumber: '',
            loaded: false,
            mode: this.$route.params.mode,
            dispatchNote: new DispatchNote({
                id: this.$route.params.id,
                iban: this.$store.state.user.client.iban[0],
                swift: this.$store.state.user.client.swift[0]
            }),
            dispatchNoteValidation: new DispatchNote({}, true),
            selectedCustomer: null,
            selectedProduct: null,
            taxBases: [],
            tempTaxBases: [],
            total: 0,
            currencyReadonly: false,
            originalCustomerId: null,
            newCustomerData: null,
            customerChanged: false,
            timeOfIssue: {
                date: null,
                time: null
            },
            timeOfIssueValidation: {
                date: '',
                time: ''
            },
            sequences: [],
            showCurrency: false,
            currencyEndpoint: 'select/currencies',
            showAddCustomerModal: false,
            showDetails: false
        }
    },
    computed: {
        headers() {
            let headers = [
                {
                    text: '',
                    sortable: false,
                    value: 'actions',
                    width: '50px',
                    class: 'pa-0'
                },
                {
                    text: this.$LANG.Get('fields.description'),
                    sortable: false,
                    value: 'description',
                    class: 'pa-0 description-width'
                },
                {
                    text: this.$LANG.Get('fields.measurementUnit'),
                    sortable: false,
                    value: 'measurement_unit',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.price') + ' (' + this.dispatchNote.currency + ')',
                    sortable: false,
                    value: 'price',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.quantity'),
                    sortable: false,
                    value: 'quantity',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.discount'),
                    sortable: false,
                    value: 'discount',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.total') + ' (' + this.dispatchNote.currency + ')',
                    sortable: false,
                    value: 'total',
                    class: 'pa-0',
                    width: "100px"
                }
            ]
            if (this.dispatchNote.tax_system && !this.dispatchNote.ppo) {
                headers.splice(5, 0, {
                    text: this.$LANG.Get('fields.tax'),
                    sortable: false,
                    value: 'tax',
                    class: 'pa-0',
                    width: "100px"
                })
            }
            return headers;
        },
        ibanOptions() {
            let options = [];
            let current = this.dispatchNote.iban;
            let currentExists = false;
            for (let iban of this.$store.state.user.client.iban) {
                if (iban === current) currentExists = true;
                options.push({
                    label: iban,
                    value: iban
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        },
        swiftOptions() {
            let options = [];
            let current = this.dispatchNote.swift;
            let currentExists = false;
            for (let swift of this.$store.state.user.client.swift) {
                if (swift === current) currentExists = true;
                options.push({
                    label: swift,
                    value: swift
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        }
    },
    watch: {
        'dispatchNote.locale': function () {
            if (this.loaded) {
                let vm = this;
                for (let i = 0; i < this.dispatchNote.items.length; i++) {
                    if (this.dispatchNote.items[i].product_id !== null) {
                        this.$API.APICall('get', 'products/' + this.dispatchNote.items[i].product_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.product['name_' + vm.dispatchNote.locale] !== undefined) ? data.product['name_' + vm.dispatchNote.locale] : data.product.name;
                                if (newName != '') vm.dispatchNote.items[i].description = newName;
                            }
                        }, false);
                    }
                }
                this.dispatchNote.footer = this.$store.state.user.client['dispatch_note_footer_template_' + this.dispatchNote.locale];
                this.dispatchNote.ppo_text = this.dispatchNote.ppo ? this.$store.state.user.client['ppo_template_' + this.dispatchNote.locale] : '';
            }
        },
        'dispatchNote.customer_id': function () {
            if (this.dispatchNote.customer_id != null) {
                let vm = this;
                this.$API.APICall('get', 'customers/' + this.dispatchNote.customer_id, {}, (data, success) => {
                    if (success) {
                        vm.selectedCustomer = data.customer;
                    }
                });
            } else {
                this.selectedCustomer = null;
            }
        },
        'selectedProduct': function () {
            if (this.selectedProduct != null) {
                this.addItem();
            }
        },
        'dispatchNote.items': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'dispatchNote.ppo': {
            handler: function () {
                this.calculateTotals();
                if (this.loaded) {
                    this.dispatchNote.ppo_text = this.dispatchNote.ppo ? this.$store.state.user.client['ppo_template_' + this.dispatchNote.locale] : '';
                }
            },
            deep: true
        },
        'dispatchNote.discount': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'dispatchNote.currency': {
            handler: function () {
                this.loadCurrencyRate();
            },
            deep: true
        },
        'timeOfIssue': {
            handler: function () {
                this.showCurrency = false;
                this.currencyEndpoint = 'select/currencies';
                if (this.timeOfIssue.date + ' ' + this.timeOfIssue.time < this.$store.state.settings.EUR_TRANSITION) {
                    this.currencyEndpoint = 'select/currencies-hrk';
                }
                this.$nextTick(() => {
                    this.dispatchNote.time_of_issue = this.timeOfIssue.date + ' ' + this.timeOfIssue.time;
                    this.showCurrency = true;
                });
            },
            deep: true
        },
        'dispatchNote.time_of_issue': {
            handler: function () {
                this.timeOfIssue.date = this.dispatchNote.time_of_issue.split(' ')[0];
                this.timeOfIssue.time = this.dispatchNote.time_of_issue.split(' ')[1];
                if (this.dispatchNote.time_of_issue > moment().format('YYYY-MM-DD') + ' 23:59:59') {
                    this.dispatchNote.currency = this.$HELPERS.GetDefaultCurrency();
                    this.currencyReadonly = true;
                    this.loadCurrencyRate();
                } else {
                    this.currencyReadonly = false;
                    this.loadCurrencyRate();
                }
            },
            deep: true
        }
    },
    methods: {
        addCustomerDone(customerId) {
            this.showAddCustomerModal = false;
            if (customerId) {
                this.dispatchNote.customer_id = customerId;
            }
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        loadCurrencyRate() {
            let vm = this;
            let oldRate = this.dispatchNote.currency_rate;
            let loaded = this.loaded;
            this.$API.APICall('get', 'currencies/' + this.dispatchNote.currency, {date: this.dispatchNote.time_of_issue}, (data, success) => {
                if (success) {
                    if (data.rate != null) {
                        vm.dispatchNote.currency_rate = data.rate;
                        if (loaded) {
                            for (let index in vm.dispatchNote.items) {
                                let item = vm.dispatchNote.items[index];
                                let price = Big(item.price);
                                vm.dispatchNote.items[index]['price'] = ((price * oldRate).toFixed(2) / Big(data.rate)).toFixed(2);
                            }
                        }
                    }
                }
            }, false);
        },
        calculateTotals() {
            this.tempTaxBases = [];
            this.total = Big(0);
            for (let index in this.dispatchNote.items) {
                let item = this.dispatchNote.items[index];
                let total = Big(item.price).times(Big(item.quantity));
                total = Big(total.toFixed(2));
                let item_discount = total.times(Big(item.discount)).div(Big(100));
                item_discount = item_discount.toFixed(2);
                total = total.minus(item_discount);
                total = Big(total.toFixed(2));
                let total_with_discount = total;
                let discount_amount = total_with_discount.times(Big(this.dispatchNote.discount)).div(Big(100));
                discount_amount = Big(discount_amount.toFixed(2));
                total_with_discount = total_with_discount.minus(discount_amount);
                if (this.dispatchNote.tax_system && !this.dispatchNote.ppo) {
                    this.addToTempBase(item.tax, total_with_discount);
                }
                this.dispatchNote.items[index]['total'] = total.toFixed(2);
                this.total = this.total.add(total_with_discount.toFixed(2));
            }
            this.taxBases = JSON.parse(JSON.stringify(this.tempTaxBases));
            if (this.dispatchNote.tax_system && !this.dispatchNote.ppo) {
                this.total = Big(0);
                for (let index in this.taxBases) {
                    let currentBase = this.taxBases[index];
                    let currentTaxAmount = (Big(currentBase.value).times(Big(currentBase.base)).div(Big(100))).toFixed(2);
                    this.total = this.total.add(currentTaxAmount).add(Big(currentBase.value));
                }
            }
        },
        addToTempBase(base, value) {
            let term = false;
            for (let index in this.tempTaxBases) {
                let currentBase = this.tempTaxBases[index];
                if (currentBase.base === base) {
                    term = true;
                    currentBase.value = Big(currentBase.value).add(Big(value)).toString();
                }
            }
            if (!term) {
                this.tempTaxBases.push({
                    base: base,
                    value: Big(value).toString()
                });
            }
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            if (this.dispatchNote.customer_id !== this.originalCustomerId) {
                this.saveAction();
            } else {
                if (!this.customerChanged) {
                    this.saveAction();
                } else {
                    let vm = this;
                    this.$LOCAL_BUS.TriggerEvent('popup', {
                        type: 'confirm',
                        text: this.$LANG.Get('alerts.customerChangesQuestionDispatchNote'),
                        callback: (response) => {
                            if (response) {
                                vm.dispatchNote.customer_data = JSON.parse(JSON.stringify(vm.newCustomerData));
                                vm.customerChanged = false;
                            }
                            vm.saveAction();
                        }
                    });
                }
            }
        },
        saveAction() {
            let success = true;

            if (this.dispatchNote.customer_id == null) {
                success = false;
                this.dispatchNoteValidation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.dispatchNoteValidation.customer_id = '';
            }

            if ((this.dispatchNote.time_of_issue == null) || (!this.$HELPERS.DateTimePattern().test(this.dispatchNote.time_of_issue))) {
                success = false;
                this.timeOfIssueValidation.time = this.$LANG.Get('labels.timeOfIssueMissing');
            } else {
                this.timeOfIssueValidation.time = '';
            }

            let itemsValidation = '';
            if (this.dispatchNote.items.length === 0) {
                success = false;
                itemsValidation = this.$LANG.Get('labels.noItems');
            } else {
                itemsValidation = '';
            }
            let termDescription = false;
            let termNegative = false;
            for (let item of this.dispatchNote.items) {
                if (item.description === '') {
                    termDescription = true;
                    break;
                }
                if (item.quantity < 0 || item.price < 0) {
                    termNegative = true;
                    break;
                }
            }
            if (termDescription) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.emptyItem');
            }
            if (termNegative) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.negativeItem');
            }
            this.dispatchNoteValidation.items = itemsValidation;

            if (success) {
                let data = JSON.parse(JSON.stringify(this.dispatchNote));
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.mode === 'edit') {
                    action = 'put';
                    addition = '/' + this.dispatchNote.id;
                }
                this.$API.APICall(action, 'dispatch-notes' + addition, data, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-dispatch-notes', {});
                        if (action === 'post') {
                            vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        } else {
                            vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        }
                        if (vm.mode === 'add' || vm.mode === 'copy' || vm.mode === 'invoice' || vm.mode === 'offer') {
                            vm.backClick();
                        }
                    } else {
                        if (data.error === 'invalid sequence later') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.dispatchNoteSequenceLater'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid sequence earlier') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.dispatchNoteSequenceEarlier'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid year') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.dispatchNoteInvalidYear'),
                                type: 'alert'
                            });
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }
                });
            }
        },
        addItem() {
            if (this.selectedProduct === null) return;
            if (this.selectedProduct === -1) {
                let newItem = {
                    description: '',
                    details: '',
                    price: 0,
                    quantity: 1,
                    tax: this.$store.state.settings.DEFAULT_TAX,
                    discount: 0,
                    measurement_unit_id: (this.$store.state.user.client.default_measurement_unit_id !== null) ? this.$store.state.user.client.default_measurement_unit_id : 1,
                    total: 0,
                    product_id: null
                }
                if (!this.$store.state.user.client.tax_system) newItem.tax = 0;
                this.dispatchNote.items.push(newItem);
                this.$nextTick(() => {
                    this.selectedProduct = null;
                });
            } else {
                let vm = this;
                this.$API.APICall('get', 'products/' + this.selectedProduct, {}, (data, success) => {
                    if (success) {
                        let newItem = {
                            description: (data.product['name_' + vm.dispatchNote.locale] !== undefined) ? data.product['name_' + vm.dispatchNote.locale] : data.product.name,
                            details: '',
                            price: data.product.price * this.dispatchNote.currency_rate,
                            quantity: 1,
                            tax: data.product.tax,
                            discount: 0,
                            measurement_unit_id: data.product.measurement_unit_id,
                            total: 0,
                            product_id: data.product.id
                        }
                        if (this.dispatchNote.time_of_issue < this.$store.state.settings.EUR_TRANSITION) {
                            newItem.price = data.product.price / this.dispatchNote.currency_rate;
                        }
                        vm.dispatchNote.items.push(newItem);
                        vm.selectedProduct = null;
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }, false);
            }
        },
        removeItemClick(index) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.dispatchNote.items.splice(index, 1);
                    }
                }
            });
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-save',
                html: this.$LANG.Get('help.save'),
                left: -100,
                top: 0,
                width: 150
            },
            {
                class: 'help-back',
                html: this.$LANG.Get('help.back'),
                left: 85,
                top: -30,
                width: 300
            },
            {
                class: 'help-dates',
                html: this.$LANG.Get('help.dates'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-item',
                html: this.$LANG.Get('help.item'),
                left: 300,
                top: -30,
                width: 300
            },
            {
                class: 'help-ppo',
                html: this.$LANG.Get('help.ppo'),
                left: 300,
                top: -50,
                width: 500
            }
        ]);

        this.$store.commit('selectMenu', 'dispatchNotes');
        this.$store.commit('selectSubMenu', null);

        this.sequences = this.$store.state.user.dispatch_note_sequences;
        if (this.sequences.length > 0) {
            this.dispatchNote.dispatch_note_sequence_id = this.$store.state.user.default_dispatch_note_sequence_id;
        } else {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.dispatchNotes'),
                    link: '/dispatch-notes'
                },
                {
                    label: this.$LANG.Get('modules.newDispatchNote'),
                    link: null
                }
            ]);

            this.dispatchNote.tax_system = this.$store.state.user.client.tax_system;
            this.dispatchNote.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
            this.dispatchNote.footer = this.$store.state.user.client['dispatch_note_footer_template_' + this.$store.state.locale];
            this.dispatchNote.locale = this.$store.state.locale;

            this.$nextTick(() => {
                this.loaded = true;
            });
        } else if (this.mode === 'edit') {
            let vm = this;
            this.$API.APICall('get', 'dispatch-notes/' + this.dispatchNote.id, {}, (data, success) => {
                if (success) {
                    if (data.dispatch_note !== null) {
                        vm.dispatchNote.Fill(data.dispatch_note);
                        vm.showDetails = vm.dispatchNote.items.some(item => item.details && item.details !== '');
                        vm.customerChanged = data.dispatch_note.customer_changed;
                        vm.originalCustomerId = data.dispatch_note.customer_id;
                        vm.newCustomerData = data.dispatch_note.new_customer_data;
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.dispatchNotes'),
                                link: '/dispatch-notes'
                            },
                            {
                                label: vm.dispatchNote.number,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        } else if (this.mode === 'copy') {
            let vm = this;
            this.$API.APICall('get', 'dispatch-notes/' + this.dispatchNote.id, {}, (data, success) => {
                if (success) {
                    vm.dispatchNote.id = 0;
                    vm.dispatchNote.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
                    vm.dispatchNote.customer_id = data.dispatch_note.customer_id;
                    vm.dispatchNote.currency = data.dispatch_note.currency;
                    if (vm.dispatchNote.time_of_issue >= this.$store.state.settings.EUR_TRANSITION && vm.dispatchNote.currency === 'HRK') {
                        vm.dispatchNote.currency = 'EUR';
                    }
                    let items = JSON.parse(JSON.stringify(data.dispatch_note.items));
                    for (let i = 0; i < items.length; i++) {
                        items[i].id = undefined;
                    }
                    vm.dispatchNote.items = items;
                    vm.showDetails = vm.dispatchNote.items.some(item => item.details && item.details !== '');
                    vm.dispatchNote.payment_method_id = data.dispatch_note.payment_method_id;
                    vm.dispatchNote.ppo = data.dispatch_note.ppo;
                    vm.dispatchNote.ppo_text = data.dispatch_note.ppo_text;
                    vm.dispatchNote.discount = data.dispatch_note.discount;
                    vm.dispatchNote.footer = data.dispatch_note.footer;
                    vm.dispatchNote.tax_system = vm.$store.state.user.client.tax_system;
                    vm.dispatchNote.locale = data.dispatch_note.locale;

                    this.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.dispatchNotes'),
                            link: '/dispatch-notes'
                        },
                        {
                            label: this.$LANG.Get('modules.newDispatchNote'),
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        } else if (this.mode === 'invoice') {
            let vm = this;
            this.$API.APICall('get', 'invoices/' + this.dispatchNote.id, {}, (data, success) => {
                if (success) {
                    vm.invoiceNumber = data.invoice.number;

                    let tempData = JSON.parse(JSON.stringify(data.invoice));
                    tempData.id = 0;
                    tempData.invoice_id = vm.$route.params.id;
                    tempData.tax_system = vm.$store.state.user.client.tax_system;
                    tempData.dispatch_note_sequence_id = vm.$store.state.user.default_dispatch_note_sequence_id;

                    tempData.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');

                    tempData.customer_changed = false;
                    tempData.locale = data.invoice.locale;

                    tempData.footer = vm.$store.state.user.client['dispatch_note_footer_template_' + tempData.locale];

                    for (let index in tempData.items) {
                        tempData.items[index].id = undefined;
                    }

                    vm.dispatchNote.Fill(tempData);
                    vm.showDetails = tempData.items.some(item => item.details && item.details !== '');

                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.dispatchNotes'),
                            link: '/dispatch-notes'
                        },
                        {
                            label: this.$LANG.Get('modules.dispatchNoteFromInvoice') + ' ' + vm.invoiceNumber,
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        } else if (this.mode === 'offer') {
            let vm = this;
            this.$API.APICall('get', 'offers/' + this.dispatchNote.id, {}, (data, success) => {
                if (success) {
                    vm.offerNumber = data.offer.number;

                    let tempData = JSON.parse(JSON.stringify(data.offer));
                    tempData.id = 0;
                    tempData.offer_id = vm.$route.params.id;
                    tempData.tax_system = vm.$store.state.user.client.tax_system;
                    tempData.dispatch_note_sequence_id = vm.$store.state.user.default_dispatch_note_sequence_id;

                    tempData.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');

                    tempData.customer_changed = false;
                    tempData.locale = data.offer.locale;

                    tempData.footer = vm.$store.state.user.client['dispatch_note_footer_template_' + tempData.locale];

                    for (let index in tempData.items) {
                        tempData.items[index].id = undefined;
                    }

                    vm.dispatchNote.Fill(tempData);
                    vm.showDetails = tempData.items.some(item => item.details && item.details !== '');

                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.dispatchNotes'),
                            link: '/dispatch-notes'
                        },
                        {
                            label: this.$LANG.Get('modules.dispatchNoteFromInvoice') + ' ' + vm.offerNumber,
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 300px;
    margin-bottom: 10px;
}

.form-float {
    width: 300px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 15px;
}

.form-float h2 {
    margin: 0 0 5px;
}

.customer-details {
    margin: 5px;
}

.items-card {
    clear: both;
}

.details-button {
    float: right;
    margin-bottom: 5px;
}

.items-container {
    clear: both;
    overflow-x: auto;
    white-space: nowrap;
}

.footer-container {
    margin-top: 10px;
    width: calc(100% - 20px);
}

.item-select {
    max-width: 500px;
}

.items-table {
    width: 100%;
    min-width: 1000px;
}

.items-table-header td {
    font-size: 12px;
    padding-left: 5px;
}

.items-table td {
    vertical-align: top;
}

.items-table-buttons {
    text-align: center;
}

.items-table-buttons span {
    cursor: pointer;
}

/* Match the button box to the field input (same 13px vertical padding) and offset it by the
   field wrapper's 5px top padding, so the buttons line up with the first row of inputs. */
.items-table-buttons .nevs-button {
    padding: 13px;
    margin-top: 5px;
}

.summary-table {
    float: right;
    margin-top: 30px;
    width: 400px;
}

.bank-field {
    max-width: 400px;
}

@media only screen and (max-width: 500px) {
    .summary-table {
        float: none;
    }
}

</style>